let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5VC0G")).then(() => parcelRequire('dlc8Q'));